import { BlockDataForm, SidebarPortal } from '@plone/volto/components';
import type { BlockEditProps } from '@plone/types';
import { PowerBIBlockView } from './View';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  powerBIUrl: {
    id: 'powerBIUrl',
    defaultMessage: 'PowerBI url',
  },
  powerBIPageName: {
    id: 'powerBIPageName',
    defaultMessage: 'Page name within paginated report',
  },
  powerBIVisualName: {
    id: 'powerBIVisualName',
    defaultMessage: 'Visual name within page',
  },
});

const PowerBIBlockSchema = ({ intl }) => {
  return {
    title: 'PowerBI',

    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['url', 'pageName', 'visualName'],
      },
    ],

    properties: {
      url: {
        title: intl.formatMessage(messages.powerBIUrl),
        widget: 'text',
        default:
          'https://app.powerbi.com/groups/60df29e4-6780-46d9-a54c-7faf19e525f4/reports/b05ab5f0-2eb3-47ff-9940-17d28ad8709b',
      },
      pageName: {
        title: intl.formatMessage(messages.powerBIPageName),
        // TODO It would be nice to have a select widget,
        // with the choices from the 'getPages' call.
        // And then similarly for visualName below.
        widget: 'text',
        default: '',
      },
      visualName: {
        title: intl.formatMessage(messages.powerBIVisualName),
        widget: 'text',
        default: '',
      },
    },
    required: ['url'],
  };
};

export type PowerBIBlockData = {
  '@type': string;
  url: null | string;
  pageName: null | string;
  visualName: null | string;
};

export const PowerBIBlockEdit = (
  props: BlockEditProps & {
    data: PowerBIBlockData;
  },
) => {
  const { selected, onChangeBlock, block, data, blocksErrors } = props;
  const schema = PowerBIBlockSchema(props);
  return (
    <>
      <PowerBIBlockView {...props} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          title={schema.title}
          schema={schema}
          onChangeBlock={onChangeBlock}
          onChangeField={(
            id: keyof typeof data,
            value: (typeof data)[keyof typeof data],
          ) => onChangeBlock(block, { ...data, [id]: value })}
          formData={data}
          block={block}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};
